import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { AlertComponent } from 'components/_basic/AlertComponent';

import { IFormTableErrorProps } from './types';

export const FormTableError: React.FC<IFormTableErrorProps> = ({ message }) => {
  const { t } = useTranslation();

  return (
    <AlertComponent
      sx={{ marginTop: 2, height: 44, display: 'flex', alignItems: 'center' }}
      severity="error"
      message={
        <Typography variant="subtitle2">
          <Typography variant="subtitle2" component="span" fontWeight={700}>
            {t('total')}
          </Typography>
          &nbsp;
          {t('shouldMatch')}
          &nbsp;
          {message}
          {'.'}
          &nbsp;
          {t('correctToHaveDataVisualization')}
        </Typography>
      }
    />
  );
};
